module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "centered add-document"
  }, [_c('router-link', {
    staticClass: "button-wrapper link",
    attrs: {
      "to": {
        name: 'BrokerInformationCreator'
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить информацию\n      ")])], 1), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "is-multiline documents"
  }, [_c('b-table', {
    attrs: {
      "html": "",
      "data": _vm.data,
      "bordered": false,
      "striped": false,
      "narrowed": false,
      "selectable": false,
      "checkable": true,
      "mobile-cards": false,
      "paginated": true,
      "per-page": 50,
      "render-html": ""
    },
    on: {
      "dblclick": _vm.edit,
      "check": _vm.checked
    }
  }, [_c('b-table-column', {
    attrs: {
      "field": "date",
      "label": "Дата публикации",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "title",
      "label": "Заголовок",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "disabled": !_vm.data.length
    },
    on: {
      "click": _vm.deleteItems
    }
  }, [_vm._v("Удалить")])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e67d07e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BrokerInformation.vue
// module id = 896
// module chunks = 0